// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme-th .avue-breadcrumb[data-v-c25bd550]{display:none}.viewEditBtn[data-v-c25bd550]{color:#f18b62!important;background-color:#f18b62!important;color:#fff!important}.editBtn[data-v-c25bd550]{text-align:center;border-color:#f18b62!important;color:#f18b62!important;border-style:dashed}[data-v-c25bd550] .top-bar__item{padding:0 15px;margin:0}", ""]);
// Exports
module.exports = exports;
